import { rpcOptional } from './rpc';

/**
 * PDPA consent evidence.
 *
 * What the member ticked is captured at the moment they tick it and carried in
 * the GoTrue signup payload, so a sign-up on a laptop still records consent
 * when the link is opened on a phone. But user metadata is member-editable, so
 * it is only the carrier — the append-only consent_ledger is the evidence, and
 * the server copies the values across on first authenticated load.
 *
 * The RPCs land with P7. Until then this records nothing and says so once;
 * failing loudly here would block sign-up over a table that does not exist yet.
 */

/**
 * Remember what was ticked at sign-up, in case the server-side sync is not
 * available yet. Deliberately NOT the source of truth — see the note above.
 */
export function recordSignupConsent(payload) {
  try {
    window.sessionStorage.setItem('ihsanone_pending_consent', JSON.stringify(payload));
  } catch {
    /* private mode */
  }
}

/** Copy sign-up consent into the ledger, server-side. Safe to call repeatedly. */
export function syncSignupConsent() {
  return rpcOptional('consent_sync_from_signup', {});
}

/**
 * Record a consent decision taken inside the app — the marketing toggle in
 * Settings, for instance. Withdrawal is a row too: the ledger is append-only,
 * so "granted false" is how consent is taken back.
 */
export function recordConsent(purpose, granted) {
  return rpcOptional('consent_record', {
    p_purpose: purpose,
    p_granted: Boolean(granted),
    p_policy_version: process.env.REACT_APP_PRIVACY_VERSION || '2026-09',
  });
}
